export default __webpack_public_path__ + "static/reseau-temporaire-img-1965895830af30343638df7cc49c7548.png";